/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type Shipping_viewer = {
    readonly regionalInfo?: ReadonlyArray<{
        readonly regionsByZipCode: ReadonlyArray<{
            readonly displayName: string | null;
        } | null> | null;
    } | null> | null;
    readonly " $refType": "Shipping_viewer";
};
export type Shipping_viewer$data = Shipping_viewer;
export type Shipping_viewer$key = {
    readonly " $data"?: Shipping_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"Shipping_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "Shipping_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "fetchRegionalInfo",
      "type": "Boolean",
      "defaultValue": false
    },
    {
      "kind": "LocalArgument",
      "name": "userZipCode",
      "type": "String",
      "defaultValue": ""
    },
    {
      "kind": "LocalArgument",
      "name": "userCountryCode",
      "type": "String",
      "defaultValue": ""
    }
  ],
  "selections": [
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "fetchRegionalInfo",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "regionalInfo",
          "storageKey": null,
          "args": [
            {
              "kind": "Variable",
              "name": "countryCode",
              "variableName": "userCountryCode"
            },
            {
              "kind": "Variable",
              "name": "zipCode",
              "variableName": "userZipCode"
            }
          ],
          "concreteType": "RegionalInfo",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "regionsByZipCode",
              "storageKey": null,
              "args": null,
              "concreteType": "RegionsByZipCode",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "displayName",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = 'fcc5cc89dc5eb0a25df29127b255663a';
export default node;
